var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import React, { useRef } from 'react';
import { useCloseHandlers } from './useCloseHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
export var Toast = function Toast(_ref) {
  var className = _ref.className,
      show = _ref.show,
      afterClose = _ref.afterClose,
      autoDismiss = _ref.autoDismiss,
      children = _ref.children;
  var container = useRef(null);

  var _useCloseHandlers = useCloseHandlers({
    afterClose: afterClose,
    autoDismiss: autoDismiss,
    container: container,
    show: show
  }),
      closeState = _useCloseHandlers.closeState;

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(StyledToast, {
      "data-test-id": "errorToast",
      className: cx(className, closeState),
      ref: container,
      children: /*#__PURE__*/_jsx(StyledContent, {
        children: /*#__PURE__*/_jsx(StyledMessageAndIcon, {
          children: /*#__PURE__*/_jsx(ToastText, {
            role: "alert",
            "data-test-id": "toastMessage",
            children: children
          })
        })
      })
    })
  });
};
var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1g18aq2"
});
var StyledToast = /*#__PURE__*/styled("div")({
  name: "StyledToast",
  class: "s17z6uql"
});
var StyledContent = /*#__PURE__*/styled("div")({
  name: "StyledContent",
  class: "sjn137c"
});
export var StyledMessageAndIcon = /*#__PURE__*/styled("div")({
  name: "StyledMessageAndIcon",
  class: "s1x4wlnp"
});
var ToastText = /*#__PURE__*/styled("span")({
  name: "ToastText",
  class: "t1l6ccuw"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/notifications/Toast.linaria.module.css");